// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
// Sibling imports
const Header = require('./component-dumb')

function mapStateToProps(state) {
  return {
    // Values
    user: state.user.loggedIn ? state.user : null
  }
}

const mapDispatchToProps = {
  onLoginClick: authModalActions.showLogin
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    Header
  )
)
